import {stringify} from 'qs'
import request from 'crm/utils/request'
import api from 'crm/common/api/customer-fissions'

export async function fissionInfo() {
    return request(api.fissionInfo.url)
}

export async function customerFissions(payload) {
    return request(`${api.customerFissions.url}?${stringify(payload)}`)
}

export async function fissionStatByDate(payload) {
    return request(`${api.fissionStatByDate.url}?${stringify(payload)}`)
}

export async function fissionStatSummary(payload) {
    return request(`${api.fissionStatSummary.url}?${stringify(payload)}`)
}

export async function fissionActivity(payload = {}) {
    return request(api.fissionActivity.url, {
        method: api.fissionActivity.type,
        body: payload.body,
    })
}
